import is from '@sindresorhus/is';
import { createContext, type FunctionComponent, type PropsWithChildren, useContext } from 'react';

import { ChatComposerConversationContext } from '../chat-composer-contexts';
import { type AgUiChatConversation, useChatConversation } from './hooks/use-chat-conversation';

const AgUiChatConversationContext = createContext<AgUiChatConversation | null>(null);

export const AgUiChatConversationProvider: FunctionComponent<PropsWithChildren> = ({ children }) => {
    const conversation = useChatConversation();

    return (
        <AgUiChatConversationContext.Provider value={conversation}>
            <ChatComposerConversationContext.Provider value={conversation}>
                {children}
            </ChatComposerConversationContext.Provider>
        </AgUiChatConversationContext.Provider>
    );
};

export const useAgUiChatConversation = (): AgUiChatConversation => {
    const value = useContext(AgUiChatConversationContext);
    if (is.null(value)) {
        throw new Error('useAgUiChatConversation must be used within an AgUiChatConversationProvider');
    }
    return value;
};
